<template>
  <UiCard>
    <div slot="title">
      <div class="title">
        Тариф CODE: <div class="title_value">{{ name }}</div>
      </div>
    </div>

    <div slot="content">
      <UiCardContentLine v-for="(s, i) in services" :key="`s-${i}`" class="card_content_line">
        <span slot="title">{{ s.title }}</span>
        <span slot="value">{{ s.value }}</span>
      </UiCardContentLine>

      <UiCardContentTitle v-if="hasOptions" class="card_content_line">
        Подключенные услуги
      </UiCardContentTitle>
      <UiCardContentLine v-for="(o, k) in options" :key="`o-${k}`" class="card_content_line">
        <span slot="title">{{ o.title }}</span>
        <span slot="value">{{ o.value }}</span>
      </UiCardContentLine>

      <UiCardContentTitle v-if="hasMarketplaces" class="card_content_line">
        Маркетплейс
      </UiCardContentTitle>
      <UiCardContentLine v-for="(m, j) in marketplaces" :key="`m-${j}`" class="card_content_line">
        <span slot="title">{{ m.title }}</span>
        <span slot="value">{{ m.value }}</span>
      </UiCardContentLine>
    </div>

    <div slot="footer">
      <UiCardContentLine class="card_content_line">
        <span slot="title">Платеж за 30 дней</span>
        <span slot="value">{{ total }}</span>
      </UiCardContentLine>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiCardContentLine from '@/components/card/UiCardContentLine.vue'
import UiCardContentTitle from '@/components/card/UiCardContentTitle.vue'
import currentApplicationMixin from '../mixins/currentApplicationMixin'

import helpers from './helpers'

export default {
  components: { UiCard, UiCardContentLine, UiCardContentTitle },
  mixins: [currentApplicationMixin, helpers],
  computed: {
    name() {
      return this.getValue('tariff.name') || '—'
    },
    services() {
      return [
        {
          title: 'Стоимость',
          value: this.getFormattedValue(this.getValue('tariff.cost')),
        },
        {
          title: 'Слотов',
          value: this.getValue('slots.slots'),
        },
      ]
    },

    hasOptions() {
      return this.options && this.options.length
    },
    options() {
      const options = this.getValue('tariffoptions') || []

      return options
        .filter((o) => o.type === 0)
        .map((o) => {
          return {
            title: o.name,
            value: this.getFormattedValue(o.cost),
          }
        })
    },

    hasMarketplaces() {
      return this.marketplaces && this.marketplaces.length
    },
    marketplaces() {
      const options = this.getValue('marketplaces') || []

      return options.map((o) => {
        return {
          title: o.name,
          value: this.getFormattedValue(o.cost),
        }
      })
    },

    total() {
      const cost = parseFloat(this.getValue('tariff.cost'))
      const slots = parseFloat(this.getValue('slots.slots'))

      // Total cost of options
      const options = this.getValue('tariffoptions') || []
      const optionsCost = options
        .filter((o) => o.type === 0)
        .map((o) => parseFloat(o.cost))
        .reduce((total, amount) => total + amount, 0)

      return this.getFormattedValue(cost * slots + optionsCost)
    },
  },
}
</script>
